import { Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

type SpinArrowProps = {
  open: boolean;
  className?: string;
};

const SpinArrow = (props: SpinArrowProps) => {
  const open = props.open;
  const className = props.className;
  const [hideArrow, setHideArrow] = useState<boolean>(false);

  return (
    <div className={className}>
      <Transition
        as={"div"}
        show={open}
        enter="transform transition duration-300 ease-in-out"
        enterFrom="rotate-0"
        enterTo="rotate-180"
        entered="transform transition rotate-180"
        leave="transform transition duration-300 ease-in-out"
        leaveFrom="rotate-180"
        leaveTo="rotate-0"
        beforeEnter={() => {
          setHideArrow(true);
        }}
        afterLeave={() => {
          setHideArrow(false);
        }}
      >
        <ChevronDownIcon className="text-primary-blue" />
      </Transition>
      {!hideArrow && <ChevronDownIcon className="text-primary-blue" />}
    </div>
  );
};

export default SpinArrow;
